// sessionStorage counterparts of ./localStorage. Values are stored as JSON;
// failures (storage unavailable, full or holding corrupt JSON) are swallowed,
// so callers never need their own try/catch.

export const loadSessionState = (name) => {
  try {
    const serializedState = sessionStorage.getItem(name);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveSessionState = (name, state) => {
  try {
    sessionStorage.setItem(name, JSON.stringify(state));
  } catch (err) {
    //
  }
};

export const removeSessionState = (name) => {
  try {
    sessionStorage.removeItem(name);
  } catch (err) {
    //
  }
};
